import { render, staticRenderFns } from "./WorkOrderPlaceholderTab.vue?vue&type=template&id=722f1382"
import script from "./WorkOrderPlaceholderTab.vue?vue&type=script&lang=js"
export * from "./WorkOrderPlaceholderTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports